import { ADD_NEW_BOOK, EDIT_BOOK, LOAD_BOOKS, OPEN_EDIT_MODE, REMOVE_BOOK } from "./actionTypes"

export const loadBooks = (books) => {
   return {
    type: LOAD_BOOKS,
    payload: books,
   } 
}

export const addNewBook = (bookData) => {
   return {
      type: ADD_NEW_BOOK,
      payload: bookData
   }
}

export const removeBook = (bookId) => {
   return {
      type: REMOVE_BOOK,
      payload: bookId,
   }
}

export const openEditMode = (bookData) => {
   return {
      type: OPEN_EDIT_MODE,
      payload: bookData,
   }
}

export const editBook = (bookData) => {
   return {
      type: EDIT_BOOK,
      payload: bookData
   }
}

